import { snapshot } from 'valtio';
import { calcDateRange } from '../../app/store-actions/top-bar-store-actions';
import TopBarStore from '../../app/stores/top-bar-store';
import { getAppOwnersStore } from '../../application-owners/api/applications-owners-api';
import { createSimpleAsyncAction } from 'async-utils';
import { loadDashboardInfo } from '../../executive-summary/actions/executive-summary-actions';
import pipelineSummaryService from '../services';
import PipelineSummaryFiltersStore from '../store/pipeline-summary-filters-store';
import { setTotalPipelineSummaryFilters } from '../store/pipeline-summary-filters-store-actions';
import PipelineSummaryStore from '../store/pipeline-summary-store';
import {
  setPipelineSummary,
  setPipelineSummaryOffset,
  setPipelineSummaryTotal,
} from '../store/pipeline-summary-store-actions';

export type LoadPipelineSummaryParams = {
  update?: boolean;
  cache?: boolean;
};
export const loadPipelineSummary = createSimpleAsyncAction(
  async (params?: LoadPipelineSummaryParams) => {
    const { update = false } = params || {};
    if (update) PipelineSummaryStore.offset = 0;
    const { dateRange } = snapshot(TopBarStore);
    const [from, to] = calcDateRange(dateRange);
    const { total, offset } = snapshot(PipelineSummaryStore);
    const { filterBy } = snapshot(PipelineSummaryFiltersStore);
    const { displaySelectedAppOwners } = getAppOwnersStore();

    if (total < offset) return;
    const response = await pipelineSummaryService.getPipelineSummary.execute({
      offset: offset,
      limit: 100,
      owners: displaySelectedAppOwners,
      dateRange: {
        from,
        to,
      },
      filters: filterBy,
    });
    if (response && response.pipelineSummaries) {
      const { offset, pipelineSummaries, total, totalFiltered } = response;
      loadDashboardInfo();
      setPipelineSummaryOffset(offset);
      setPipelineSummary(pipelineSummaries, update);
      setPipelineSummaryTotal(total);
      setTotalPipelineSummaryFilters(totalFiltered);
    }
  },
  {
    asyncState: PipelineSummaryStore.loading,
    errorMessage: 'Failed to load pipeline summary data',
  },
);
